module.exports = __webpack_public_path__ + "static/media/car.ffa10bd6.svg";